<div class="search">
  <input matInput [placeholder]="placeholder" [formControl]="form" />
  <mat-icon svgIcon="search" [attr.aria-label]="placeholder"></mat-icon>
</div>
